import { BusinessProcessService, OrganizationThemeService } from '@/services';

const getBusinessProcesses = async ({ dispatch }) => {
  const businessProcesses = await BusinessProcessService.getBusinessProcesses();
  dispatch('setBusinessProcesses', businessProcesses);
};

const setBusinessProcesses = ({ commit }, payload) => {
  if (payload.length > 0) {
    commit('setBusinessProcesses', payload);
  }
};

const setSelectedBusinessProcesses = ({ commit }, payload) => {
  commit('setSelectedBusinessProcesses', payload);
};

const getCustomizedBusinessProcesses = async ({ commit, getters }) => {
  const organizationId = getters.organizationId;
  const response = await OrganizationThemeService.getCustomizedUris(organizationId);
  commit('setCustomizedBusinessProcesses', response);
};

export default {
  getBusinessProcesses,
  setBusinessProcesses,
  setSelectedBusinessProcesses,
  getCustomizedBusinessProcesses
};
